<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<bom-info-search ref="bomInfoSearch" :scrId="scrId" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 시작-->
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<bom-info-table ref="table" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 끝-->
		</div>
	</div>
</template>

<script>
import BomInfoSearch from './Search/BomInfoSearch.vue';
import BomInfoTable from './Table/BomInfoTable.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { BomInfoSearch, BomInfoTable },
	methods: {
		Refresh() {
			this.$sf_toggleLoading(false);
			this.$refs.bomInfoSearch.searchList();
		}
	}
};
</script>

<style></style>
